import React from "react";
const PlaybackIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 0C13.187 0 17 3.813 17 8.5C17 13.187 13.187 17 8.5 17C3.813 17 0 13.187 0 8.5C0 3.813 3.813 0 8.5 0ZM8.5 1C4.364 1 1 4.364 1 8.5C1 12.636 4.364 16 8.5 16C12.636 16 16 12.636 16 8.5C16 4.364 12.636 1 8.5 1ZM6.764 5.0594C6.926 4.9714 7.125 4.9814 7.277 5.0844L11.777 8.0834C11.917 8.1754 12 8.3324 12 8.4994C12 8.6664 11.917 8.8224 11.777 8.9154L7.277 11.9164C7.194 11.9714 7.097 12.0004 7 12.0004C6.919 12.0004 6.838 11.9804 6.764 11.9404C6.602 11.8534 6.5 11.6844 6.5 11.5004V5.5004C6.5 5.3154 6.602 5.1464 6.764 5.0594ZM7.5 6.4344V10.5654L10.599 8.4994L7.5 6.4344Z",
      fill: "currentColor"
    }
  )
);
var PlaybackIcon_default = PlaybackIcon;
export {
  PlaybackIcon_default as default
};
//# sourceMappingURL=PlaybackIcon.js.map
